import { useMutation, useQuery } from '@tanstack/react-query'
import { httpClient } from './httpClient'

export const KEYS = {
  HELP_ARTICLES: 'help-articles',
}

const getHelpArticles = async ({ category = null, locale = 'en', q = '', page = 1 } = {}) => {
  const response = await httpClient.get('/help-center/articles', {
    params: {
      language: locale,
      q,
      category_id: category,
      page,
    },
  })
  return response.data
}
export const getHelpArticlesKey = ({ category = null, locale = 'en', q = '', page = 1 } = {}) => [
  KEYS.HELP_ARTICLES,
  `locale=${locale}`,
  `category_id=${category}`,
  `q=${q}`,
  `page=${page}`,
]

export const useHelpArticles = (params) =>
  useQuery(getHelpArticlesKey(params), async () => getHelpArticles(params), {
    keepPreviousData: true,
  })
export const prefetchHelpArticles = (queryClient, params) =>
  queryClient.prefetchQuery(getHelpArticlesKey(params), async () => getHelpArticles(params))

const getHelpArticle = async (slug) => {
  const response = await httpClient.get(`/help-center/articles/${slug}`)
  return response.data
}
export const getHelpArticleKey = (slug, { locale = 'en' } = {}) => [
  KEYS.HELP_ARTICLES,
  `slug=${slug}`,
  `locale=${locale}`,
]
export const useHelpArticle = (slug, params) =>
  useQuery(getHelpArticleKey(slug, params), async () => getHelpArticle(slug), {
    keepPreviousData: true,
  })
export const prefetchHelpArticle = (queryClient, slug, params) =>
  queryClient.prefetchQuery(getHelpArticleKey(slug, params), async () => getHelpArticle(slug))

export const useHelpArticleFeedback = () =>
  useMutation((payload) => httpClient.post('/help-center/feedback', payload))
